/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        footnoteBodyPaddingBottom: 32,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 16,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 16
      }
    },
    {
      if: { viewport: [ 'md', 'lg' ] },
      tokens: {
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 24
      }
    },
    {
      if: { viewport: [ 'xl' ] },
      tokens: {
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 16,
        footnoteHeaderPaddingTop: 24
      }
    }
  ],
  tokens: {
    closeButtonBackgroundColor: '#f4f4f7',
    closeButtonBorderColor: '#676e73',
    closeButtonBorderSize: 1,
    closeButtonHeight: 24,
    closeButtonIconSize: 16,
    closeButtonMarginBottom: 12,
    closeButtonMarginLeft: 4,
    closeButtonMarginRight: 4,
    closeButtonMarginTop: 12,
    closeButtonWidth: 24,
    closeIcon: PaletteIconClose,
    footnoteBackground: '#f4f4f7',
    footnoteBodyBackground: '#f4f4f7',
    footnoteBodyPaddingBottom: 40,
    footnoteBodyPaddingLeft: 16,
    footnoteBodyPaddingRight: 16,
    footnoteBodyPaddingTop: 0,
    footnoteBorderColorMd: '#b2b9bf',
    footnoteBorderTopSizeMd: 1,
    footnoteHeaderPaddingBottom: 24,
    footnoteHeaderPaddingLeft: 16,
    footnoteHeaderPaddingRight: 4,
    footnoteHeaderPaddingTop: 24,
    headerFontName: 'HNforTELUSSA',
    headerFontSize: 16,
    headerFontWeight: '500',
    headerLineHeight: 1.5,
    headerMargin: 16,
    listItemColor: '#414547',
    listItemFontName: 'HNforTELUSSA',
    listItemFontSize: 16,
    listItemFontWeight: '400',
    listItemLineHeight: 1.5,
    listItemMarkerFontSize: 16,
    listItemMarkerLineHeight: 1.5,
    listItemPaddingLeft: 8,
    listPaddingLeft: 32
  }
}
export default theme
